import type { TopicExercises } from "~/features/computer/data/exercises/exercise.types";

export const sdlcExercises: TopicExercises = {
  mcqs: [
    {
      id: "sdlc-1",
      difficulty: "easy",
      question: "SDLC ka main purpose kya hai?",
      options: [
        "Random coding start karna",
        "Software banane ko step-by-step plan karna",
        "Sirf testing karna",
        "Sirf diagrams banana",
      ],
      correctIndex: 1,
      explanation: "Correct answer 'Software banane ko step-by-step plan karna' hai kyun ke SDLC ka kaam project ko ordered stages me divide karna hota hai. 'Random coding' galat hai kyun ke SDLC planning ke baghair kaam nahi karta.",
    },
    {
      id: "sdlc-2",
      difficulty: "easy",
      question: "Functional requirement kya batati hai?",
      options: [
        "System ka color theme",
        "System kya kaam karega",
        "Internet speed",
        "Team size",
      ],
      correctIndex: 1,
      explanation: "Correct answer 'System kya kaam karega' hai kyun ke functional requirement feature ya action batati hai, jaise login ya search. Color theme aur speed functional nahi, balke doosri categories me aati hain.",
    },
    {
      id: "sdlc-3",
      difficulty: "easy",
      question: "Non-functional requirement kis cheez se related hoti hai?",
      options: [
        "System kitna fast aur reliable hai",
        "Login button ka text",
        "User ka naam",
        "Code ka variable",
      ],
      correctIndex: 0,
      explanation: "Correct answer 'System kitna fast aur reliable hai' hai kyun ke non-functional requirement quality, speed, security aur performance ko cover karti hai. Ye feature ka naam nahi, balke system ki quality batati hai.",
    },
    {
      id: "sdlc-4",
      difficulty: "medium",
      question: "Waterfall model kaisa hota hai?",
      options: [
        "Small cycles me kaam hota hai",
        "Step-by-step linear process hota hai",
        "Without planning coding hoti hai",
        "Sirf testing par focus hota hai",
      ],
      correctIndex: 1,
      explanation: "Correct answer 'Step-by-step linear process hota hai' hai kyun ke Waterfall me phases aik fixed order me chalti hain. 'Small cycles' Agile ki taraf jata hai, is liye woh option galat hai.",
    },
    {
      id: "sdlc-5",
      difficulty: "medium",
      question: "Agile model ka basic idea kya hai?",
      options: [
        "Sab kuch aik hi dafa launch karna",
        "Small cycles me improve karna",
        "Sirf design banana",
        "Risk ignore karna",
      ],
      correctIndex: 1,
      explanation: "Correct answer 'Small cycles me improve karna' hai kyun ke Agile ka core idea iterations aur feedback hai. Agile me project ko chhote sprints me better banaya jata hai, aik hi dafa sab kuch final nahi hota.",
    },
    {
      id: "sdlc-6",
      difficulty: "medium",
      question: "Planning phase me kya socha jata hai?",
      options: [
        "Budget, scope aur risk",
        "Sirf logo design",
        "Sirf final launch date",
        "Sirf compiler install karna",
      ],
      correctIndex: 0,
      explanation: "Correct answer 'Budget, scope aur risk' hai kyun ke planning phase project ki direction decide karti hai. Logo design ya compiler install planning ka poora concept represent nahi karte.",
    },
    {
      id: "sdlc-7",
      difficulty: "hard",
      question: "Use Case Diagram kis cheez ko simple form me dikhata hai?",
      options: [
        "Code ki line count",
        "User system ke sath kya interaction karta hai",
        "Internet package",
        "Team attendance",
      ],
      correctIndex: 1,
      explanation: "Correct answer 'User system ke sath kya interaction karta hai' hai kyun ke Use Case Diagram actor aur system ke actions dikhata hai. Is ka relation coding lines ya attendance se nahi hota.",
    },
    {
      id: "sdlc-8",
      difficulty: "hard",
      question: "Debugger ka role kya hota hai?",
      options: [
        "Code ko translate karna",
        "Bugs dhoondhna aur step-by-step code check karna",
        "Server host karna",
        "Requirements likhna",
      ],
      correctIndex: 1,
      explanation: "Correct answer 'Bugs dhoondhna aur step-by-step code check karna' hai kyun ke debugger execution ko inspect karta hai. Code translate karna compiler ka kaam hota hai, debugger ka nahi.",
    },
  ],
  short: [
    {
      id: "sdlc-short-1",
      question: "SDLC important kyun hai?",
      answer: "SDLC important hai kyun ke yeh software development ko organized banata hai. Jab planning, design, development aur testing alag clear stages me hoti hain to bugs kam hotay hain, time waste nahi hota aur cost control me rehti hai.",
    },
    {
      id: "sdlc-short-2",
      question: "Functional aur non-functional requirements me farq kya hai?",
      answer: "Functional requirements batati hain system kya karega, jaise user login kar sake. Non-functional requirements batati hain system kaise perform karega, jaise fast ho, secure ho aur reliable ho. Is liye aik feature batati hai aur doosri quality batati hai.",
    },
    {
      id: "sdlc-short-3",
      question: "Agile aur Waterfall me aik basic difference batao.",
      answer: "Waterfall linear order follow karta hai, yani aik stage ke baad doosri stage aati hai. Agile me project small cycles ya sprints me chalta hai jahan feedback ke baad improvement hoti rehti hai.",
    },
  ],
  long: [
    {
      id: "sdlc-long-1",
      question: "SDLC ke core stages explain karo.",
      solution: "SDLC ke core stages aik sequence me software ko stable banati hain. Planning project ka direction set karti hai, design structure banati hai, development code likhti hai, testing bugs pakarti hai aur deployment final software ko users tak pohanchati hai.",
      steps: [
        "Planning: scope, budget aur risk socho.",
        "Design: system ka structure aur screens decide karo.",
        "Development: actual coding karo.",
        "Testing: bugs aur errors check karo.",
        "Deployment: software ko users ke liye release karo.",
      ],
    },
    {
      id: "sdlc-long-2",
      question: "Use Case Diagram ka purpose explain karo.",
      solution: "Use Case Diagram ka purpose yeh dikhana hota hai ke kaun sa user system ke sath kya action karta hai. Is se project ke functions ko simple visual form me samajhna easy hota hai aur requirements clear hoti hain.",
      steps: [
        "Actor identify karo, jaise student ya admin.",
        "System ke main actions likho, jaise login ya register.",
        "Actor aur actions ke darmiyan relation dikhao.",
      ],
    },
  ],
};
